import React from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutePaths } from '../../routes/main-routes';
import { PageWrapper, StyledBlueHeading, StyledContainer } from '../../components/styled/styles';
import { BackNavigationHeader } from '../../components/styled/back-navigation-header';
import { createAlgorithm } from '../../api/studykit';
import { AlgorithmForm, AlgorithmFormFields } from '../../components/algorithms/algorithm-form';
import { SubmitHandler } from 'react-hook-form';
import { useSWRConfig } from 'swr';

function AddAlgorithm() {
  let navigate = useNavigate();
  const { mutate } = useSWRConfig();

  const handleSubmit: SubmitHandler<AlgorithmFormFields> = async (data) => {
    const newAlgorithm = {
      name: data.name,
      repository: data.repository,
      privateKey: data.privateKey[0],
    };
    mutate(`/algorithms`, createAlgorithm(newAlgorithm));

    navigate(`/${RoutePaths.Settings}/${RoutePaths.Algorithms}`);
  };

  return (
    <PageWrapper>
      <BackNavigationHeader navigateTo={`/${RoutePaths.Settings}/${RoutePaths.Algorithms}`} />
      <StyledContainer>
        <StyledBlueHeading
          variant="h2"
          weight="weight-400"
          style={{ padding: '0 24px', margin: '0' }}
        >
          Add algorithm
        </StyledBlueHeading>

        <AlgorithmForm onSubmit={handleSubmit} onCancel={() => {}} />
      </StyledContainer>
    </PageWrapper>
  );
}

export default AddAlgorithm;
